<template>
    <grid ref="grid" :columnDefs="columnDefs" :fetchCallback="fetchCallback">
        <export-to-excel-button :href="excelHref" />
    </grid>
</template>

<script>
    import api from '../../../../api';
    import { ADMIN_SUBSCRIBER_USERS } from '../../../../endpoints';
    import grid from '../../../generic/grid/grid.vue';
    import { mapGetters } from 'vuex';
    import ExportToExcelButton from '../../../generic/export-to-excel-button/export-to-excel-button.vue';
    import ActionsCellRenderer from './actions-cell-renderer.vue';

    export default {
        name: 'SubscriberPayments',
        components: {
            grid,
            ExportToExcelButton,
            actionsCellRenderer: ActionsCellRenderer,
        },
        data() {
            return {
                offset: 0,
                limit: 20,
                sort: 'id',
                desc: true,
                search: '',
            };
        },
        inject: ['userId'],
        computed: {
            ...mapGetters('header', ['userUnicodeDateFormat']),
            endDateRequest() {
                return format(this.dateRange.to, this.dateRequestFormat);
            },
            startDateRequest() {
                return format(this.dateRange.from, this.dateRequestFormat);
            },
            excelHref() {
                return `${ADMIN_SUBSCRIBER_USERS(this.userId)}excel/?offset=${this.offset}&limit=${this.limit}&search=${
                    this.search
                }&desc=${this.desc}&sort=${this.sort}`;
            },
            columnDefs() {
                return [
                    {
                        field: 'id',
                        headerName: 'ID',
                        maxWidth: 100,
                        minWidth: 100,
                    },
                    {
                        field: 'date_joined',
                        headerName: 'Date Joined',
                        type: 'dateColumn',
                        minWidth: 140,
                        maxWidth: 140,
                    },
                    {
                        field: 'first_name',
                        headerName: 'First Name',
                        minWidth: 150,
                    },
                    {
                        field: 'last_name',
                        headerName: 'Last Name',
                        minWidth: 150,
                    },
                    {
                        field: 'email',
                        headerName: 'Email',
                        minWidth: 220,
                    },
                    {
                        field: 'is_active',
                        headerName: 'Active',
                        type: 'yesNoColumn',
                        maxWidth: 100,
                        minWidth: 100,
                        headerClass: 'yes-no-centered-header',
                        cellClass: 'd-flex justify-content-center',
                    },
                    {
                        field: 'is_validated',
                        headerName: 'Validated',
                        type: 'yesNoColumn',
                        maxWidth: 130,
                        minWidth: 130,
                        headerClass: 'yes-no-centered-header',
                        cellClass: 'd-flex justify-content-center',
                    },
                    {
                        field: 'group',
                        headerName: 'Group',
                        minWidth: 150,
                        sortable: false,
                    },
                    {
                        field: '',
                        cellRenderer: 'actionsCellRenderer',
                        minWidth: 150,
                        maxWidth: 150,
                        cellRendererParams: {
                            logInAsUser: (id) => {
                                try {
                                    window.location = `/administrative/login_as_user/${id}`;
                                } catch (e) {
                                    this.errorToast({ text: 'Could not log in' });
                                }
                            },
                        },
                    },
                ];
            },
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return api.get(`${ADMIN_SUBSCRIBER_USERS(this.userId)}users/`, {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
    };
</script>

<style lang="scss" scoped>
    :deep(.yes-no-centered-header) {
        .ag-header-cell-label {
            justify-content: center;
        }
    }
</style>
